import { Link } from "react-router-dom";
import { Gamepad2, LayoutGrid, Wrench, PhoneCall, ArrowRight } from "lucide-react";

const BENEFITS = [
  [Gamepad2, "Add games to your store or route", "Skill-game cabinets placed where your customers already are — one location or a whole route."],
  [LayoutGrid, "Fortune boards and machines", "Fortune Games boards and 43-inch cabinets, sold outright so the revenue from the floor stays with you."],
  [Wrench, "Setup support", "Delivery, install and a one-year parts and labor warranty, with a real person on the phone when you need one."],
];

// Home-page section for operators and store owners; "Request a call" lands on the existing Fortune quote form.
export default function OperatorsSection() {
  return (
    <section id="operators" data-testid="operators-section" className="border-t border-border/60 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 py-14 sm:py-20 grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neon-yellow" data-testid="operators-kicker">For operators and store owners</div>
          <h2 data-testid="operators-headline" className="mt-3 font-heading font-black text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight">More games on your floor.<br />Nothing to figure out alone.</h2>
          <p className="mt-3 text-sm text-white/65 leading-relaxed max-w-md">Tell us about your store or route and we call you back with the right boards, the price and an install date.</p>
          <Link to="/fortune#quote" data-testid="operators-request-call" className="mt-6 inline-flex items-center gap-2 h-12 px-6 bg-neon-yellow text-black hover:bg-white transition-colors font-heading font-bold text-sm uppercase tracking-wide">
            <PhoneCall className="w-4 h-4" /> Request a call <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <ul className="lg:col-span-7 grid sm:grid-cols-3 gap-3" data-testid="operators-benefits">
          {BENEFITS.map(([Icon, title, body]) => (
            <li key={title} className="border border-border/70 bg-black/30 p-5 flex flex-col gap-3 hover:border-neon-yellow/60 transition-colors">
              <Icon className="w-5 h-5 text-neon-yellow" />
              <div className="font-heading font-bold text-base leading-snug">{title}</div>
              <p className="text-xs sm:text-[13px] text-white/60 leading-relaxed">{body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
